import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Gift, Megaphone } from "lucide-react";
import { Switch } from "@/components/ui/switch";
import { api, formatApiError } from "@/lib/api";
import { useI18n } from "@/context/I18nContext";

const Row = ({ icon: Icon, color, title, desc, checked, onChange, testid }) => (
  <div className="flex items-start gap-4">
    <Icon className="w-5 h-5 mt-0.5 shrink-0" style={{ color }} />
    <div className="flex-1 min-w-0">
      <div className="font-display text-white">{title}</div>
      <p className="text-sm text-slate-400 mt-1">{desc}</p>
    </div>
    <Switch checked={!!checked} disabled={checked === undefined} onCheckedChange={onChange} data-testid={testid} />
  </div>
);

export const NotifyPrefs = () => {
  const { t } = useI18n();
  const [p, setP] = useState({});
  useEffect(() => { api.get("/me/prefs").then((r) => setP(r.data)).catch(() => setP({ notify_bonus: true, news_email: true })); }, []);
  const toggle = (key) => async (v) => {
    setP((o) => ({ ...o, [key]: v }));
    try {
      await api.patch("/me/prefs", { [key]: v });
      toast.success(t("pref.saved"));
    } catch (e) { setP((o) => ({ ...o, [key]: !v })); toast.error(formatApiError(e)); }
  };
  return (
    <div className="cx-card rounded-2xl p-6 space-y-5" data-testid="notify-prefs">
      <Row icon={Gift} color="#ffc94d" title={t("pref.bonus_title")} desc={t("pref.bonus_desc")} checked={p.notify_bonus} onChange={toggle("notify_bonus")} testid="notify-bonus-switch" />
      <Row icon={Megaphone} color="#3ad7ff" title={t("pref.news_title")} desc={t("pref.news_desc")} checked={p.news_email} onChange={toggle("news_email")} testid="notify-news-switch" />
    </div>
  );
};
